module.exports = __webpack_public_path__ + "static/media/hinted-Whitney-SemiBold.3f1ba6df.ttf";